'use client';

import { useEffect } from 'react';
import { reportError } from '../src/lib/errors/error-reporter.client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError({
      level: 'error',
      source: 'frontend',
      context: 'app.global-error',
      message: error.message || 'Unerwarteter Fehler',
      stack: error.stack,
      metadata: { digest: error.digest },
    });
  }, [error]);

  return (
    <html lang="de">
      <body className="bg-[var(--k-color-bg-app)] text-[var(--k-color-text-primary)]">
        <main className="grid min-h-screen place-items-center px-6 py-12">
          <div className="max-w-lg text-center">
            <h1 className="text-3xl font-bold">Kritischer Fehler</h1>
            <p className="mt-4 text-sm">
              Die Anwendung konnte nicht geladen werden.
            </p>
            {error.digest ? (
              <p className="mt-2 font-mono text-xs text-[var(--k-color-text-muted)]">
                Fehler-ID: {error.digest}
              </p>
            ) : null}
            <button
              type="button"
              onClick={reset}
              className="mt-6 rounded-[var(--k-radius-md)] bg-[var(--k-color-accent)] px-4 py-2 text-sm font-bold text-white"
            >
              Erneut versuchen
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}